// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__r5jk5","ranges":"BmiRanges_ranges__1ThMT"};